import React from "react";
import MatchTypeComponent from "./MatchTypeComponent";

function FileExtractionView(props) {
  return (
    <div>
      <MatchTypeComponent
        matchType={props.matchType}
        fileName={props.fileName}
      />
    </div>
  );
}

export default FileExtractionView;
